<template>
  <div id="categoria_">
    <div id="categoria_detalhes_">
      <div id="informacoes_">
        <h2 v-if="categoria">{{ categoria.nome }}</h2>
        <section class="rowsections">
          <div v-for="subcat of subcategorias" :key="subcat._id" id="sub">
            <a :href="`${$route.path}?sub=${subcat.nome.toLowerCase()}&p=1`">
              <!-- <p id="name_btn" @click="changeSubCategoria(subcat._id)"> -->
              {{ subcat.nome }}
              <!-- </p> -->
            </a>
            <!-- <router-link
              id="name_btn"
              :to="`/${categoria.nome.toLowerCase()}?sub=${subcat.nome.toLowerCase()}`"
              >{{ subcat.nome }}</router-link
            > -->
          </div>
        </section>
        <!-- <h4 v-if="categoria" style="margin-top: 40px">Tamanhos</h4>

        <section>
          <p v-for="tamanho of tamanhos" :key="tamanho" id="sub">
            <router-link
              id="name_btn"
              :to="`${$route.path}?t=${tamanho}`"
            >{{tamanho}}</router-link>
          </p>
        </section> -->
      </div>

      <div class="ordenacao">
        <select v-model="ordenacao" @change="realizarOrdenagem()">
          <option value="recente">Mais recentes</option>
          <option value="menor">Menor preço</option>
          <option value="maior">Maior preço</option>
          <option value="visualizacao">Mais visitados</option>
        </select>
      </div>

      <div id="listagem_" v-if="produtos && produtos.length > 0">
        <div v-for="produtos_ in produtos" :key="produtos_[0]._id">
          <section class="products_">
            <Product
              v-for="product in produtos_"
              :key="product._id"
              :product="product"
            />
          </section>
        </div>

        <div>
          <!-- <div id="pages" v-for="page in pages_generated" :key="page">
            <button id="page_btn">{{page}}</button>
          </div>-->
        </div>
      </div>
      <div v-else-if="loading">
        <activity-indicator
          size="40"
          color="#000000"
          style="margin-top: 130px; margin-bottom: 130px"
        />
      </div>
      <div v-else>
        <p id="end_produc">Ops! O {{produtos}} estoque dessa categoria acabou!</p>
      </div>
    </div>
    <div id="pages">
      <div id="pagination_list" v-if="produtos && produtos.length > 0">
        <v-pagination
          v-model="page"
          color="#8d816b"
          :length="total_page"
          total-visible="5"
          @input="getPage()"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Product from "../components/Product";
export default {
  name: "app",
  components: {
    Product,
  },
  data() {
    return {
      pages_generated: [],
      ordenacao: "recente",
      categoria: null,
      total_page: 1,
      tamanhos: ["40", "42", "44"],
      page: 1,
      produtos: [],
      filtro: {
        categoria: null,
        subcategoria: null,
        ordem: 0,
      },
      subcategoria_info: null,
      loading: true,
      subcategorias: [],
    };
  },
  watch: {
    // async $route() {
    //   this.page = 1;
    //   console.log(this.$route);
    //   if (this.$route.path === "/search") {
    //     this.buscar();
    //   } else {
    //     console.log("QUERY");
    //     console.log(this.$route.query);
    //     let sub = this.$route.query.sub;
    //     console.log(sub);
    //     if (sub) {
    //       this.getProdutosSubCategorias();
    //     } else {
    //       await this.getInfo();
    //     }
    //   }
    // },
  },
  async beforeMount() {
    if (this.$route.path === "/search") {
      this.buscar();
    } else {
      // let path = this.$route.path.substring(1).split("/");

      // let sub = this.$route.query.sub;
      // console.log(this.$route.query);

      if (this.$route.query.p) {
        this.page = parseInt(this.$route.query.p);
      }

      if(this.$route.query.o){
        this.filtro.ordem = this.$route.query.o;
        switch(this.$route.query.o){
          case "0":
            this.ordenacao = 'visualizacao'
            break;
          case "1":
            this.ordenacao = 'maior'
            break;
          case "2":
            this.ordenacao = 'menor'
            break;
          default:
            this.ordenacao = 'recente'
            break;
        }
      }

      // if (sub) {
      // this.getProdutosSubCategorias();
      // } else {
      await this.getInfo();
      // }
    }
  },
  methods: {
    // async changeSubCategoria(id) {
    //   try {
    //     this.page = 1;
    //     this.filtro.subcategoria = id;
    //     alert("SUB é " + id)
    //     await this.getProdutos(this.categoria._id);
    //   } catch (err) {
    //     alert("Não foi possível carregar a subcategoria");
    //   }
    // },
    buscar(pg = 1) {
      this.$http
        .get(
          `/opens/produtos/buscar/nome/marca/${this.$route.query.q}?pg=${pg}`
        )
        .then((res) => {
          let req = res.data;
          let linha = [];

          this.total_page = req.totalPages;

          for (let e of req.docs) {
            if (e.image[0] && e.image[0].key)
              e.url = `https://api-store.emporiodasmarcas.com.br/files/product/${e.image[0].key}`;

            let qntParcelas = 1;
            while (e.preco.preco_venda / qntParcelas > 50) {
              qntParcelas++;
            }

            e.qntParcelas = qntParcelas;
          }

          for (let e = 0; e < req.docs.length; e += 4) {
            let adicao = [];
            if (req.docs[e]) adicao.push(req.docs[e]);
            if (req.docs[e + 1]) adicao.push(req.docs[e + 1]);
            if (req.docs[e + 2]) adicao.push(req.docs[e + 2]);
            if (req.docs[e + 3]) adicao.push(req.docs[e + 3]);
            // if (req.docs[e + 4]) adicao.push(req.docs[e + 4]);
            linha.push(adicao);
          }

          this.produtos = linha;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async getInfo() {
      try {
        let nomeScreen = "";
        if (this.categoria && this.categoria.nome != "") {
          nomeScreen = this.categoria.nome.toLowerCase();
        } else {
          nomeScreen = this.$route.params.categoria;
        }
        let req = await this.$http.get(`/opens/categoria/nome/${nomeScreen}`);
        this.categoria = req.data;
        if (req.data != "") {
          await this.getSubCategorias(req.data._id);


          // console.log("AQQ = " + JSON.stringify(req.data));

          // alert(JSON.stringify(req.data))
          // await this.getProdutos(req.data._id);
        }
      } catch (err) {
        // console.log(err);
        this.loading = false;
      }
    },
    async getProdutosSubCategorias() {
      // let subs = await this.$http
      //   .get(`/opens/categoria/nome/${this.$route.query.sub}`);
      //   console.log(subs.data);
      // console.log("Pg = " + this.page);
      // console.log("SUB = " + sub);
      // let nomeScreen = this.$route.params.categoria;
      //   .catch(() => {
      //     this.loading = false;
      //   });
      // this.$http
      //   .get(
      //     `/opens/subcategorias/cat/sub/${cat}/${decodeURIComponent(sub)}?pg=${
      //       this.page
      //     }`
      //   )
      //   .then((res) => {
      //     let req = res.data.docs;
      //     this.total_page = res.data.totalPages;
      //     let linha = [];
      //     for (let e of req) {
      //       e.url = `https://api-store.emporiodasmarcas.com.br/files/product/${e.image[0].key}`;
      //       let qntParcelas = 1;
      //       while (e.preco.preco_venda / qntParcelas > 50) {
      //         qntParcelas++;
      //       }
      //       e.qntParcelas = qntParcelas;
      //     }
      //     for (let e = 0; e < req.length; e += 4) {
      //       let adicao = [];
      //       if (req[e]) adicao.push(req[e]);
      //       if (req[e + 1]) adicao.push(req[e + 1]);
      //       if (req[e + 2]) adicao.push(req[e + 2]);
      //       if (req[e + 3]) adicao.push(req[e + 3]);
      //       linha.push(adicao);
      //     }
      //     this.produtos = linha;
      //     this.$forceUpdate();
      //   })
      //   .catch(() => {
      //     this.loading = false;
      //   });
    },
    async realizarOrdenagem() {
      try {
        switch (this.ordenacao) {
          case "recent":
            this.filtro.ordem = 3;
            this.makePath(3)
            // console.log("SOLICITADO");
            await this.getProdutos(this.categoria._id);
            break;
          case "menor":
            this.filtro.ordem = 2;
            this.makePath(2)
            break;
          case "maior":
            this.filtro.ordem = 1;
            this.makePath(1)
            break;
          default:
            this.$route.query.ordem=0;
            this.makePath(0)
            break;
        }
      } catch (err) {
        alert("Não foi possível carregar!");
      }
    },
    async makePath(ordem){
      if(this.$route.query.sub)
        this.$router.push(
              `/${this.$route.path}?sub=${this.$route.query.sub}&p=${this.page}&o=${ordem}`
            );
      else
        this.$router.push(
              `/${this.$route.path}?p=${this.page}&o=${ordem}`
            );
      this.$router.go();
    },
    async getSubCategorias(id) {
      try {
        let res = await this.$http.get(`/opens/subcategorias`);
        let todas = res.data.subcategorias;
        // console.log("SUBCAT");
        // console.log(todas);
        let unicas = [];

        for (let e of todas) {
          if (e && e.categoria && e.categoria === id) {
            unicas.push(e);
          }
        }

        this.subcategorias = unicas;

        if (this.$route.query.sub) {
          for (let e of unicas) {
            if (
              e.nome.toLowerCase().trim() ==
              this.$route.query.sub.toLowerCase().trim()
            ) {
              this.filtro.subcategoria = e;
              
            }
          }
        }

        await this.getProdutos();
      } catch (err) {
        alert(err);
        this.loading = false;
      }
    },
    async getProdutos() {
      try {
        // CATEGORIA - SUBCATEGORIA
        let res = null;
        
        if(this.filtro.subcategoria != null) {
          res = await this.$http.get(
            `/opens/produtos/lis/${this.filtro.subcategoria.categoria}/${this.filtro.subcategoria._id}/${this.page}/${this.filtro.ordem}`
          );
        } else{
          res = await this.$http.get(
            `/opens/produtos/lis/${this.categoria._id}/null/${this.page}/${this.filtro.ordem}`
          );
        }

        this.produtos = [];
        let req = res.data;
        let linha = [];

        if (req.docs.length === 0) {
          this.loading = false;
        }

        this.total_page = req.totalPages;

        for (let e of req.docs) {
          if (e.image[0] && e.image[0].key)
            e.url = `https://api-store.emporiodasmarcas.com.br/files/product/${e.image[0].key}`;

          let qntParcelas = 1;
          while (e.preco.preco_venda / qntParcelas > 50) {
            qntParcelas++;
          }

          e.qntParcelas = qntParcelas;
        }

        for (let e = 0; e < req.docs.length; e += 4) {
          let adicao = [];
          if (req.docs[e]) adicao.push(req.docs[e]);
          if (req.docs[e + 1]) adicao.push(req.docs[e + 1]);
          if (req.docs[e + 2]) adicao.push(req.docs[e + 2]);
          if (req.docs[e + 3]) adicao.push(req.docs[e + 3]);
          // if (req.docs[e + 4]) adicao.push(req.docs[e + 4]);
          linha.push(adicao);
        }

        this.produtos = linha;
        // console.log("produtos");
      } catch (err) {
        alert(err);
        this.loading = false;
      }
    },
    async getPage() {
      try {
        if (this.$route.path === "/search") {
          this.buscar(this.page);
        } else {
          // let path = this.$route.path.substring(1).split("/");

          let sub = this.$route.query.sub;
          let ordenacao_ = this.$route.query.o;

          // if (sub) {

          // if (this.ordenacao != "recente") {
          let pag = this.page;
          this.page = pag + 1;
          if(sub && ordenacao_){
            this.$router.push(
              `/${this.$route.path}?sub=${this.$route.query.sub}&p=${pag}&o=${ordenacao_}`
            );
          } else if (sub) {
            this.$router.push(
              `/${this.$route.path}?sub=${this.$route.query.sub}&p=${pag}`
            );
          } else if(ordenacao_){
            this.$router.push(
              `/${this.$route.path}?p=${pag}&o=${ordenacao_}`
            );
          }
          else {
            this.$router.push(`/${this.$route.path}?p=${pag}`);
          }
          this.$router.go();

          // console.log("PAG = " + pag);
          // await this.realizarOrdenagem();
          // await this.getProdutosSubCategorias();
          // await this.getInfo();
          // } else {
          // await this.getInfo();
          // }
        }
      } catch (err) {
        // console.log(err);
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, Tahoma, Verdana, sans-serif;
}

#main {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;

  background-color: #eee;
  display: flex;
  justify-content: center;
  align-items: center;
}

#categoria_ {
  display: block;
  width: 90%;
}

#end_produc {
  margin-top: 150px;
  margin-bottom: 150px;
}

#categoria_detalhes_ {
}

.ordenacao {
  display: flex;
  justify-content: flex-end;
}

.ordenacao select {
  border: 1px solid #eaeaea;
  background-color: #eaeaea;
  color: #000;
  width: 200px;
  padding: 5px;
  border-radius: 2px;
}

#informacoes_ {
  margin-top: 4em;
  padding-left: 45px;
  text-align: left;
}

#informacoes_ h2 {
  font-weight: 800;
  font-size: 25.2px;
}

#categoria_detalhes_ .rowsections {
  display: flex;
}

#listagem_ {
  display: block;
  align-items: flex-start;
}

#sub {
  margin-top: 10px;
  margin-right: 15px;
  margin-bottom: 10px;
  font-weight: 500;
}

#pages {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}

#pagination_list {
  width: 400px;
  display: block;
  justify-self: center;
}

#name_btn:hover {
  color: #e4e4e4;
}

.products_ {
  display: inline-flex;
  padding: 20px;
  margin: 0 auto;
}

@media screen and (max-width: 800px) {
  #categoria_detalhes_ {
    display: block;
  }

  #informacoes_ {
    margin-top: 4em;
    width: 80%;
    text-align: left;
    padding-left: 45px;
  }

  #listagem_ {
    display: block;
    align-items: flex-start;
  }

  .products_ {
    display: block;
    padding: 0px;
    margin: 0 auto;
  }

  #pagination_list {
    width: 100%;
    display: block;
    justify-self: center;
  }

  #categoria_ .ordenacao {
  }

  .ordenacao {
    display: flex;
    justify-content: flex-start;
    margin-left: 44px;
  }

  .ordenacao select {
    border: 1px solid #eaeaea;
    background-color: #eaeaea;
    color: #000;
    width: 200px;
    padding: 5px;
    border-radius: 2px;
  }

  #sub {
    margin-top: 10px;
    margin-right: 15px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    font-weight: 500;
  }


#categoria_detalhes_ .rowsections {
  display: flex;
  flex-direction: column;
}
}
</style>
